export const base64Decode = (str: string) => {
  const decodedString = atob(str);

  try {
    return JSON.parse(decodedString);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return null;
  }
};